import React from 'react'

export type CheckIconProps = {
  size?: number
  /** Stroke color. Defaults to `currentColor` so the parent controls theming. */
  color?: string
  className?: string
}

export const CheckIcon = ({
  size = 16,
  color = 'currentColor',
  className,
}: CheckIconProps) => (
  <svg
    aria-hidden='true'
    className={className}
    fill='none'
    height={size}
    viewBox='0 0 16 16'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M13.3333 4L6 11.3333L2.66667 8'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.73333}
    />
  </svg>
)
